<template>
  <div>
  <div class="g-ht"></div>
  <div class="header">
      <span class="menuBtn"></span>
      <div class="wp">
          <!-- <div class="logo">
              <router-link to="/"><img src="@/assets/images/logo.png" alt="" /></router-link>
          </div> -->
          <div class="h-r">
              <ul class="nav">
                  <li class="{% if pos == 1 %}on{% endif %}">
                      <router-link to="/" class="v1">会员首页</router-link>
                  </li>
                <li class="">
                  <router-link :to="userCenterPath" class="v1">会员中心</router-link>
                </li>
                <li class="">
                  <router-link :to="userOrderPath" class="v1">订单列表</router-link>
                </li>
                <li class="">
                  <a @click="logout" class="v1">退出登录</a>
                </li>
<!--                  <li class="{% if pos == 2 %}on{% endif %}">-->
<!--                      <a href="/home/index/protocol?type=bk_config_about" class="v1">关于我们</a>-->
<!--                      <div class="sub">-->
<!--                        <a href="/home/index/protocol?type=bk_config_about">关于我们</a>-->
<!--                        <a href="/home/index/protocol?type=bk_config_contact">联系我们</a>-->
<!--                        <a href="/home/index/protocol?type=bk_config_business">商务合作</a>-->
<!--                      </div>-->
<!--                  </li>-->
<!--                  <li class="{% if pos == 3 %}on{% endif %}">-->
<!--                      <a href="/home/index/protocol?type=bk_choose_vip" class="v1">在线选书</a>-->
<!--                  </li>-->
<!--                  <li class="{% if pos == 4 %}on{% endif %}">-->
<!--                      <a href="/home/index/protocol?type=bk_member_vip" class="v1">会员VIP</a>-->
<!--                  </li>-->
<!--                  <li class="{% if pos == 5 %}on{% endif %}">-->
<!--                      <a href="/home/index/protocol?type=bk_supplier_vip" class="v1">供应商</a>-->
<!--                  </li>-->
              </ul>
              <div class="h-btns">
                  <router-link to="/common-messagecenter" class="h-news" :style="{
                      backgroundImage: 'url(' + require('@/assets/images/h-a1.png') + ')',
                    }">
                      <span v-if="msgCount>0" class="num">{{ msgCount }}</span>
                  </router-link>
                  <div class="h-picuser">
                      <div class="pic" :style="{
                      backgroundImage: 'url(' + (userInfo.avatar || require('@/assets/images/h-picuser.jpg')) + ')',
                    }"></div>
                    <div class="txt">
                      <div class="name">{{ userInfo.realname || '游客' }} </div>
                      <div class="desc">ID：{{ userInfo.showId }}</div>
                    </div>
                      <!-- <div class="h-box1">
                          <div class="tip" v-if="userInfo.type<2 && !isVip">{{userInfo.type==1?'当前用户未开通供应商VIP，获取更多权限请购买供应商VIP':'当前用户未开通会员VIP，获取更多权限请购买会员VIP'}} ></div>
                          <div class="inner">
                              <div class="top">
                                  <div class="left">
                                      <div class="img">
                                          <img :src="(userInfo.avatar || require('@/assets/images/h-picuser.jpg'))" alt="">
                                      </div>
                                  </div>
                                  <div class="right">
                                      <div class="name">{{ userInfo.realname || '游客' }}</div>
                                      <div class="desc" @click="copyText(userInfo.showId)">
                                          <div class="id">ID：{{ userInfo.showId }}</div>
                                          <img src="@/assets/images/index/icon4.png" alt="">
                                      </div>
                                  </div>
                                  <router-link :to="userInfo.type!=1?'/info-center':'/suppliercenter-information'" class="myself">个人中心</router-link>
                              </div>

                              <router-link :to="userInfo.type!=1?'/center-equity':'/supplier-equity'" class="vipbox" v-if="userInfo.type<2 && !isVip">{{userInfo.type==1?'供应商VIP':'会员VIP'}} <img src="@/assets/images/index/right.png" alt="" class="icon"></router-link>
                              <div v-else style="height: 10px"></div>
                            <ul v-if="userInfo.type==0" class="h-links">
                              <li>
                                <a :href="'/home/user_info/home?id='+userInfo.showId" target="_blank" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/h-a3.png" alt="">
                                  </div>
                                  <div class="info">我的主页</div>
                                </a>
                              </li>
                              <li>
                                <router-link :to="'/center-equity'" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/h-a4.png" alt="">
                                  </div>
                                  <div class="info">我的会员</div>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/membercenter-mycollection" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/h-a6.png" alt="">
                                  </div>
                                  <div class="info">我的收藏</div>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/membercenter-myorder" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/f-a6.png" alt="">
                                  </div>
                                  <div class="info">我的订单</div>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/membercenter-submittedorder" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/f-a10.png" alt="">
                                  </div>
                                  <div class="info">已提交订单</div>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/common-myattention" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/h-a7.png" alt="">
                                  </div>
                                  <div class="info">我的关注</div>
                                </router-link>
                              </li>
                            </ul>
                            <ul v-if="userInfo.type==1" class="h-links">
                                <li>
                                    <a :href="'/home/user_info/home?id='+userInfo.showId" target="_blank" class="con">
                                        <div class="icon">
                                            <img src="@/assets/images/h-a3.png" alt="">
                                        </div>
                                        <div class="info">企业主页</div>
                                    </a>
                                </li>
                                <li>
                                    <router-link :to="'/supplier-equity'" class="con">
                                        <div class="icon">
                                            <img src="@/assets/images/h-a4.png" alt="">
                                        </div>
                                        <div class="info">我的会员</div>
                                    </router-link>
                                </li>
                                <li>
                                  <router-link to="/suppliercenter-bookmanagement" class="con">
                                    <div class="icon">
                                      <img src="@/assets/images/f-a4.png" alt="">
                                    </div>
                                    <div class="info">在线选书</div>
                                  </router-link>
                                </li>
                                <li>
                                  <router-link to="/suppliercenter-library" class="con">
                                    <div class="icon">
                                      <img src="@/assets/images/f-a5.png" alt="">
                                    </div>
                                    <div class="info">图书库</div>
                                  </router-link>
                                </li>
                                <li>
                                    <router-link to="/suppliercenter-submittedorder" class="con">
                                        <div class="icon">
                                            <img src="@/assets/images/f-a6.png" alt="">
                                        </div>
                                        <div class="info">订单管理</div>
                                    </router-link>
                                </li>
                                <li>
                                    <router-link to="/common-myattention" class="con">
                                        <div class="icon">
                                            <img src="@/assets/images/h-a7.png" alt="">
                                        </div>
                                        <div class="info">我的关注</div>
                                    </router-link>
                                </li>
                            </ul>
                            <ul v-if="userInfo.type==2" class="h-links">
                              <li>
                                <router-link :to="'/info-center'" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/f-a2.png" alt="">
                                  </div>
                                  <div class="info">我的信息</div>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/membercenter-projectmanagement" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/h-a5.png" alt="">
                                  </div>
                                  <div class="info">项目管理</div>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/membercenter-myorder" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/f-a6.png" alt="">
                                  </div>
                                  <div class="info">我的订单</div>
                                </router-link>
                              </li>
                              <li>
                                <router-link to="/membercenter-submittedorder" class="con">
                                  <div class="icon">
                                    <img src="@/assets/images/f-a10.png" alt="">
                                  </div>
                                  <div class="info">已提交订单</div>
                                </router-link>
                              </li>
                            </ul>
                              <div class="dw">
                                  <a @click="logout">退出登录</a>
                              </div>
                          </div>
                      </div> -->
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>
</template>

<script>
import dayjs from "dayjs";

export default {

    data() {
      return {}
    },
    computed: {
      userInfo() {
          return this.$store.state.user.userInfo || {}
      },
      isVip(){
          return this.userInfo.vipTime ? dayjs(this.userInfo.vipTime).isAfter(dayjs()) : false
      },
      msgCount(){
          return this.$store.state.user.msgCount || 0
      },
      userCenterPath(){
        switch (parseInt(this.userInfo.type)){
          case 0: // 注册会员
            return '/home-center'
          case 1: // 供应商
            return '/home-supplier'
          case 2: // 选书会员
            return '/info-center'
        }
        return '/home-center'
      },
      userOrderPath(){
        switch (parseInt(this.userInfo.type)){
          case 0: // 注册会员
            return '/membercenter-myorder'
          case 1: // 供应商
            return '/suppliercenter-submittedorder'
          case 2: // 选书会员
            return '/membercenter-myorder'
        }
        return '/membercenter-myorder'
      }
    },
    methods: {
        logout() {
            this.$store.dispatch('user/logout').then(() => {
                this.$router.push({path: '/login'})
            })
        },
      async copyText(text) {
        try {
          // const text = 'ID ：77885214065';
          await navigator.clipboard.writeText(text);
          console.log('文字复制成功');
          this.$message.success('复制成功');
        } catch (error) {
          console.error('文字复制失败', error);
        }
      }
    }
}
</script>
<style scoped>
.body{
    /* padding-top: 100px; */
}
.g-ht{
  height: 100px;
}
.header {
  position: fixed;
  left: 0;
  width: 100%;
  top: 0;
  background-color: #fff;
  z-index: 99;
  /* box-shadow: -1px 10px 10px rgba(0,0,0,0.04); */
}
.header .wp {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  width: 100%;
  padding: 0 70px;
}
.logo img {
  display: block;
  width: 133px;
}
.h-r {
  display: flex;
  align-items: center;
}
.nav li {
  display: inline-block;
  position: relative;
  margin-right: 50px;
}
.nav .v1 {
  display: block;
  line-height: 100px;
  font-size: 16px;
  transition: 0.3s;
}
.nav .v1:hover {
  color: #188efc;
}
.sub {
  position: absolute;
  top: 86%;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  background: #ffffff;
  box-shadow: 8px 2px 46px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  padding: 22px 10px 12px;
  display: none;
}
.sub a {
  display: block;
  text-align: center;
  color: #6f7680;
  font-size: 14px;
  transition: 0.3s;
  margin-bottom: 12px;
}
.sub a:hover {
  color: #222529;
}
.h-btns {
  display: flex;
  align-items: center;
}
.h-news {
  display: block;
  width: 20px;
  height: 24px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: relative;
}
.h-news .num {
  position: absolute;
  display: inline-block;
  width: 26px;
  line-height: 18px;
  height: 18px;
  text-align: center;
  background: #ff1a25;
  /* font-family: Arial; */
  font-weight: 400;
  font-size: 13px;
  border-radius: 8px;
  top: -10px;
  right: -10px;
  color: #fff;
}
.h-picuser {
  position: relative;
  margin-left: 40px;
  display: flex;
  align-items: center;
}
.h-picuser .name{
  font-size: 18px;
}
.h-picuser .desc{
  font-size: 12px;
  color: #404449;
}
.h-picuser .pic {
  width: 58px;
  height: 58px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  margin-right: 8px;
}
.h-picuser:hover .h-box1 {
  display: block;
}
.h-box1 {
  position: absolute;
  right: 0;
  top: 100%;
  background: #ffffff;
  box-shadow: 8px 2px 46px 0px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  /* border: 1px solid #E8E8E8; */
  display: none;
  width: 370px;
}
.h-box1:hover {
    display: block;
}
.h-box1 .tip {
  line-height: 34px;
  font-size: 12px;
  color: #f73a0b;
  background-position: left 14px center;
  background-size: 14px auto;
  background-repeat: no-repeat;
  background-image: url(@/assets/images/h-a8.png);
  background-color: #edf3f9;
  padding-left: 34px;
}
.h-box1 .inner {
  padding: 25px 25px 18px;
}
.h-box1 .top {
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 90px;
  margin-bottom: 12px;
}
.h-box1 .top .left {
  margin-right: 9px;
  width: 58px;
  float: none;
}
.h-box1 .top .right {
  flex: 1;
  float: none;
}
.h-box1 .top .img {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  overflow: hidden;
}
.h-box1 .top .img img {
  display: block;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}
.h-box1 .top .myself {
  width: 74px;
  line-height: 25px;
  background: #edf3f9;
  border-radius: 13px;
  text-align: center;
  display: inline-block;
  overflow: hidden;
  font-size: 12px;
  color: #6f7680;
  position: absolute;
  right: 0;
  bottom: 10px;
}
.h-box1 .top .name {
  font-size: 18px;
}
.h-box1 .top .desc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #808080;
  font-size: 12px;
}
.h-box1 .top .desc img {
  display: block;
  width: 52px;
  height: auto;
}
.h-box1 .vipbox {
  line-height: 43px;
  background-color: #edf3f9;
  border-radius: 4px;
  font-size: 16px;
  color: #505153;
  background-position: left 12px center;
  background-size: 20px auto;
  background-repeat: no-repeat;
  background-image: url(@/assets/images/h-a2.png);
  padding-left: 42px;
  margin-bottom: 20px;
  display: block;
  position: relative;
}
.h-box1 .vipbox .icon{
  display: block;
  width: 6px;
  height: auto;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.h-links {
  overflow: hidden;
}
.h-links li {
  float: left;
  width: 33.3%;
  padding: 0 10px;
  margin-bottom: 22px;
  text-align: center;
}

.h-links .con:hover .info {
  color: #188efc;
}
.h-links .icon {
  height: 24px;
  margin-bottom: 5px;
}
.h-links .icon img {
  display: block;
  margin: 0 auto;
  width: 22px;
  max-height: 23px;
}
.h-links .info {
  font-size: 14px;
  color: #404449;
  height: 1.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  display: box;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  transition: 0.3s;
}
.h-box1 .dw {
  text-align: right;
}
.h-box1 .dw a {
  display: inline-block;
  color: #6f7680;
  font-size: 12px;
  transition: 0.3s;
}
.h-box1 .dw a:hover {
  color: #188efc;
}
</style>
